// extracted by mini-css-extract-plugin
export var container = "Switcher-module--container--9455a";
export var sm = "Switcher-module--sm--4a9b5";
export var label = "Switcher-module--label--597a7";
export var switcher = "Switcher-module--switcher--ac5d6";
export var reverseColors = "Switcher-module--reverseColors--03058";
export var input = "Switcher-module--input--f0684";